import React, {useEffect} from 'react';
import ScormProvider from "./scorm";
import ScormPlayer from "./components/Player";

const App = () => {

    let pageWidth = null;
    let pageHeight = null;
    let basePage = {
        width: 1280,
        height: 814,
        scale: 1,
        scaleX: 1,
        scaleY: 1,
    };

    useEffect(() => {
        getPageSize();
        scalePages(pageWidth, pageHeight);
    }, []);


    useEffect(() => {
        window.addEventListener('resize', handleResize);
        window.addEventListener('load', handleResize)
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    const handleResize = () => {
        getPageSize();
        scalePages(pageWidth, pageHeight);
    };

    const getPageSize = () => {
        pageHeight = document.getElementById('app-container').clientHeight;
        pageWidth = document.getElementById('app-container').clientWidth;
    };

    const scalePages = (maxWidth, maxHeight) => {
        let scaleX = 1;
        let scaleY = 1;
        scaleX = maxWidth / basePage.width;
        scaleY = maxHeight / basePage.height;
        basePage.scaleX = scaleX;
        basePage.scaleY = scaleY;
        basePage.scale = scaleX > scaleY ? scaleY : scaleX;

        const newLeftPos = Math.abs(Math.floor((basePage.width * basePage.scale - maxWidth) / 2));
        const newTopPos = Math.abs(Math.floor((basePage.height * basePage.scale - maxHeight) / 2));

        const playerPage = document.getElementById('player');
        if (playerPage) {
            playerPage.style.transform = 'scale(' + basePage.scale + ')';
            playerPage.style.left = newLeftPos + 'px';
            playerPage.style.top = newTopPos + 'px';
        }
    };

    return (
        <div id="app-container"
             className="App">
            {
                <ScormProvider>
                    <ScormPlayer/>
                </ScormProvider>
            }
        </div>

    );
};

export default App;
